import { IFormBuilder } from '../IFormBuilder';
import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { FormControl } from '@angular/forms';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { BaryValidator } from '../../../validators/bary.validator';
import { IOfferHandlingType } from '../../offer-handling-type.model';

interface IOfferHandlingTypeFormBuilder extends IFormBuilder<OfferHandlingTypeControls> {
  init(): IOfferHandlingTypeFormBuilder;

  build(): IGenericBaryFormGroup<OfferHandlingTypeControls>;
}

export type OfferHandlingTypeControls = {
  id: FormControl;
  activated: FormControl;
  type: FormControl;
  minWidth: FormControl;
  minLength: FormControl;
  minHeight: FormControl;
  maxWidth: FormControl;
  maxLength: FormControl;
  maxHeight: FormControl;
  maxVolume: FormControl;
  minQuantity: FormControl;
  maxQuantity: FormControl;
  minOtherQuantity: FormControl;
  maxOtherQuantity: FormControl;
  minWeight: FormControl;
  maxWeight: FormControl;
  maxWeightWithTailgate: FormControl;
  offer: FormControl;
};

export class OfferHandlingTypeFormBuilder implements IOfferHandlingTypeFormBuilder {
  private formName = 'offerHandlingForm';
  private controls!: OfferHandlingTypeControls;

  constructor(private bcf: BaryFormFactoryService) {}

  initOfferHandlingType(offerHandlingType?: IOfferHandlingType): OfferHandlingTypeFormBuilder {
    this.controls = this.bcf.makeOfferHandlingTypeControls(offerHandlingType);
    return this;
  }

  build(): IGenericBaryFormGroup<OfferHandlingTypeControls> {
    return new GenericBaryFormGroup<OfferHandlingTypeControls>(this.formName, this.controls, [
      BaryValidator.hasMinValueLowerThanMaxValue(this.controls.minQuantity, this.controls.maxQuantity),
      BaryValidator.hasMinValueLowerThanMaxValue(this.controls.minWeight, this.controls.maxWeight),
      BaryValidator.hasMinValueLowerThanMaxValue(this.controls.minWidth, this.controls.maxWidth),
      BaryValidator.hasMinValueLowerThanMaxValue(this.controls.minLength, this.controls.maxLength),
      BaryValidator.hasMinValueLowerThanMaxValue(this.controls.minHeight, this.controls.maxHeight),
      BaryValidator.hasMinValueLowerThanMaxValue(this.controls.minOtherQuantity, this.controls.maxOtherQuantity),
    ]);
  }

  init(): IOfferHandlingTypeFormBuilder {
    return new OfferHandlingTypeFormBuilder(this.bcf);
  }
}
